import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
    constructor(
        private snackbarService: SnackbarService,
        private errorHandler: ErrorHandler
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error?.error?.errorReasonCode?.includes('Duplicate')) return throwError(() => error);
                if (error?.error?.errorMessage) this.snackbarService.openErrorSnackbar(error?.error?.errorMessage);

                // consumers like rxResource/rxMethod catch stream errors internally and never let them
                // reach the global ErrorHandler on their own, so forward every failed request here instead
                this.errorHandler.handleError(error);

                return throwError(() => error);
            })
        );
    }
}
